import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTemplatePlaceholderRow } from '../../../../hooks/useTemplatePlaceholderRow';
import { TemplatePlaceholderRowProps } from './types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { TextField } from '@mui/material';
import BrushIcon from '../../../../../../../static/assets/svg/brush.svg';
import { ProgressOverlay } from '../../../../../../common/progress-overlay/ProgressOverlay';
import MessageModal from '../../../../../../common/message-modal/MessageModal';

const TemplatePlaceholderRow = ({
  data,
  id,
  index,
  documentHTMLId,
  deletePlaceholder,
}: TemplatePlaceholderRowProps) => {
  const { t } = useTranslation();
  const {
    field,
    setField,
    setPlaceholder,
    placeholder,
    placeholderIdValue,
    value,
    setValue,
    editMode,
    setEditMode,
    handleSavePlaceholder,
    pendingStatus,
    setDeletePlaceholderMessageVisible,
    deletePlaceholderMessageVisible,
  } = useTemplatePlaceholderRow({ data, id, documentHTMLId });
  return (
    <tr>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.field')}
          variant='outlined'
          size='medium'
          value={field}
          onChange={(e) => setField(e.target.value)}
          disabled={Boolean(placeholderIdValue)}
        />
      </td>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.value')}
          variant='outlined'
          size='medium'
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={Boolean(placeholderIdValue)}
        />
      </td>
      <td style={{ paddingBottom: '16px' }}>
        <TextField
          fullWidth
          label={t('labels.placeholder')}
          variant='outlined'
          size='medium'
          value={placeholder}
          onChange={(e) => setPlaceholder(e.target.value)}
          disabled={Boolean(placeholderIdValue) && !editMode}
        />
      </td>
      <td className='vertical-align-middle' style={{ paddingBottom: '16px' }}>
        <div className='d-flex align-items-center'>
          <Tooltip title={t('messages.deleteTemplatePlaceholder')} placement='top' arrow>
            <IconButton
              aria-label='delete'
              onClick={() => setDeletePlaceholderMessageVisible(true)}
            >
              <DeleteOutlineOutlinedIcon
                fontSize='small'
                style={{ marginRight: 0, fill: '#152a58' }}
              />
            </IconButton>
          </Tooltip>
          <Tooltip
            title={
              placeholderIdValue
                ? editMode
                  ? t('buttons.update')
                  : t('buttons.edit')
                : t('buttons.save')
            }
            placement='top'
            arrow
          >
            <IconButton className='table-row-icon-button' onClick={() => handleSavePlaceholder()}>
              {placeholderIdValue ? (
                editMode ? (
                  <CheckCircleOutlineOutlinedIcon
                    fontSize='small'
                    style={{ marginRight: 0, fill: '#152a58' }}
                  />
                ) : (
                  <BrushIcon />
                )
              ) : (
                <CheckCircleOutlineOutlinedIcon
                  fontSize='small'
                  style={{ marginRight: 0, fill: '#152a58' }}
                />
              )}
            </IconButton>
          </Tooltip>
          {pendingStatus && <ProgressOverlay />}
          {deletePlaceholderMessageVisible && (
            <MessageModal
              open={deletePlaceholderMessageVisible}
              modalTitle={t('dialogTitles.deletePlaceholder')}
              modalMessage={t('messages.deletePlaceholderDialog')}
              actionButtonText={t('buttons.goBack')}
              actionButtonFn={() => {
                setDeletePlaceholderMessageVisible(false);
              }}
              goBackButtonText={t('buttons.delete')}
              onClose={() => {
                deletePlaceholder(id, index);
                setDeletePlaceholderMessageVisible(false);
              }}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

export default TemplatePlaceholderRow;
